module.exports = __webpack_public_path__ + "img/9bombas.514ef845.jpg";